import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Injector, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperModalComponent } from '../../../../../../shared/components/image-cropper-modal/image-cropper-modal.component';
import { ModalUtils } from '../../../../../../../utils/modal-utils';

@Component({
  selector: 'app-ep-self-enrolment-employer-logo',
  templateUrl: './ep-self-enrolment-employer-logo.component.html',
  styleUrls: ['./ep-self-enrolment-employer-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpSelfEnrolmentEmployerLogoComponent {
  @Input({ required: true }) fileControl!: FormControl<File[] | null>;
  @Input() formSubmitted = false;

  private cdr = inject(ChangeDetectorRef);
  private injector = inject(Injector);
  private ngbModal = inject(NgbModal);

  public handleFileChange(files: File[]): void {
    const modalRef = this.ngbModal.open(ImageCropperModalComponent, ModalUtils.defaultModalOptions(this.injector));
    const componentRef = modalRef.componentInstance as ImageCropperModalComponent;
    componentRef.imageFile = files[0];
    const control = this.fileControl;
    modalRef.result.then((croppedFile: File) => {
      control.setValue(croppedFile ? [croppedFile] : null);
      control.markAsDirty();
      control.markAsTouched();
      this.cdr.detectChanges();
    });
  }
}
